import styles from './Sobremim.module.css'

function Sobremim() {

    return (
        <section className={styles.sobremim} id='sobremim'>
            <div>
                <h1>
                    Sobre Mim
                </h1>
            </div>
            <div>
                <p>Sou <strong>desenvolvedor Node.js</strong>, organizado e comprometido com <strong>boas práticas de desenvolvimento</strong>. Possuo experiência na criação de <strong>APIs REST</strong> e <strong>arquiteturas de microserviços</strong>, utilizando <strong>JavaScript</strong>, com foco em <strong>código limpo</strong>, <strong>bem estruturado</strong> e de <strong>fácil manutenção</strong>, entre outras tecnologias.</p>

                <p>Atuo também com <strong>MySQL</strong> e <strong>MongoDB</strong>, buscando sempre <strong>eficiência</strong> e <strong>qualidade</strong> nas soluções entregues. Não me limito apenas às tecnologias que utilizo no dia a dia: sou <strong>curioso</strong>, estou em <strong>constante aprendizado</strong> e aberto a <strong>novos desafios</strong> e <strong>ferramentas</strong>.</p>            </div>
        </section>
    )
}

export default Sobremim